import React from "react";
import { Link } from "react-router-dom";
import { converterCategories, calculators, textTools } from "../data/tools";

export const Footer = () => {
  return (
    <footer className="border-t-2 border-ink bg-ink text-canvas mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <h3 className="font-heading font-black text-2xl uppercase tracking-tighter text-paper">
            Utili<span className="text-signal">verse</span>
          </h3>
          <p className="font-mono text-xs text-canvas/60 mt-3 leading-relaxed">
            A growing universe of fast, free, no-nonsense online tools. No sign-up. No fluff.
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal mb-3">Converters</p>
          <ul className="space-y-1.5">
            {converterCategories.slice(0, 6).map((c) => (
              <li key={c.id}>
                <Link to={`/converters/${c.id}`} className="text-sm text-canvas/80 hover:text-paper hover:underline">{c.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal mb-3">Calculators</p>
          <ul className="space-y-1.5">
            {calculators.map((c) => (
              <li key={c.slug}>
                <Link to={`/calculators/${c.slug}`} className="text-sm text-canvas/80 hover:text-paper hover:underline">{c.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal mb-3">Text Tools</p>
          <ul className="space-y-1.5">
            {textTools.map((c) => (
              <li key={c.slug}>
                <Link to={`/text-tools/${c.slug}`} className="text-sm text-canvas/80 hover:text-paper hover:underline">{c.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-canvas/15">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-widest text-canvas/50">
          <span>© {new Date().getFullYear()} Utiliverse</span>
          <span>Built for speed · {converterCategories.length} converter sets + calculators</span>
        </div>
      </div>
    </footer>
  );
};
